import $ from "jquery";
import assign from "object-assign";
import reduce from "lodash/reduce";
import isMatch from "lodash/isMatch";
import { replace } from "react-router-redux";
import Cookies from "js-cookie";
import constants from "../../../../server/lib/constants";
import { createListUrl } from "../../../../server/utils/createUrls";
import clientConstants from "../../shared/constants";
import resourceTypes from "../../../../server/lib/open-planet/resourceTypes";
import ajaxError from "../../shared/actions/ajaxError";
import { topThingsListItemTypes, visibleListItemTypes } from "../../shared/listItemTypes";

const _ = { reduce, isMatch };

// Remove unchecked filters from the url
function filterRedirect({ activeFilters = {}, availability = {}, dispatch }) {
  dispatch(
    replace({
    pathname: window.location.pathname,
      query: assign({}, activeFilters, availability),
    }),
  );
}

const getActiveFilters = (filters) =>
  _.reduce(filters, (memo, value, filterType) => {
    memo[filterType] = _.reduce(value, (fMemo, filterVal, filter) => {
      if (typeof filterVal === "object" && !Array.isArray(filterVal)) {
        fMemo.push(filterVal);
      } else if (Array.isArray(filterVal)) {
        return fMemo.concat(filterVal);
      } else if (filterVal) {
        fMemo.push(filter);
      }

      return fMemo;
    }, []);
    return memo;
  }, {});

const getDataFromFilters = (activeFilters) => {
  const data = {};

  if (activeFilters.subtypes && activeFilters.subtypes.length) {
    data.subtypes = activeFilters.subtypes.join(",");
  }

  if (activeFilters.duration && activeFilters.duration.length) {
    data.duration = true;
    data.from = activeFilters.duration[0] * 60;
    data.to = activeFilters.duration[1] * 60;
  }

  if (activeFilters.price && activeFilters.price.length) {
    data.price = true;
    data.fromPrice = activeFilters.price[0];
    data.toPrice = activeFilters.price[1];
  }

  if (activeFilters.locations && activeFilters.locations.length) {
    data.locations = activeFilters.locations.join(",");
  }

  if (activeFilters.exists && activeFilters.exists.indexOf("lp_review") >= 0) {
    data.exists = "lp_review";
  }

  if (activeFilters.facilities && activeFilters.facilities.length) {
    data.facilities = activeFilters.facilities.join(",");
  }

  if (activeFilters.booking && activeFilters.booking.length) {
    if (activeFilters.booking[0].endDate) {
      data.endDate = activeFilters.booking[0].endDate;
    }
    if (activeFilters.booking[0].startDate) {
      data.startDate = activeFilters.booking[0].startDate;
    }
    if (activeFilters.booking[0].numNights) {
      data.numNights = activeFilters.booking[0].numNights;
    }

    if (data.startDate && data.endDate) {
      Cookies.set("availability", {
        startDate: data.startDate,
        endDate: data.endDate,
        numNights: data.numNights,
      });
    }
  }

  return data;
};

function initList(
  pois,
  place,
  kind,
  resource,
  filters,
  dispatch,
) {
  const active = getActiveFilters(filters);
  const activeFilters = getDataFromFilters(active);
  const availability = Cookies.getJSON("availability");

  if (typeof window !== "undefined" && Object.keys(active).length) {
    const shouldAddAvailabilityParams =
      !_.isMatch(window.location.search, availability) &&
      resource === resourceTypes.lodging;

    filterRedirect(Object.assign({},
      { activeFilters, dispatch },
      (shouldAddAvailabilityParams && { availability }) || {})
    );
  }

  return {
    type: clientConstants.INIT_LIST,
  };
}

function fetchNextListDone({
  pois,
  next,
  type,
}) {
  return {
    type,
    data: {
      pois,
      next,
    },
  };
}

function fetchNextList({
    url = "",
    type = "",
    path = typeof window !== "undefined" ? window.location.pathname : "/",
    filters = {},
    resource = "",
  }) {
  const active = getActiveFilters(filters);
  const data = getDataFromFilters(active);
  const action = type || (url ?
    clientConstants.FETCH_NEXT_LIST :
    clientConstants.FETCH_NEXT_LIST_TYPE);
  const doneAction = `${action}_DONE`;

  return function ajaxFetchNextList(dispatch) {
    $.ajax({
      url: path,
      data: Object.assign({}, data, url ? { resource: url } : {}),
      contentType: "application/json",
    })
    .done(json => dispatch(fetchNextListDone({
      pois: json.data,
      next: json.next,
      type: doneAction,
      filters: active,
    })))
    .fail((response, status) => {
      dispatch(ajaxError(path, status));
      dispatch(fetchNextListDone({
        pois: [],
        next: "",
        type: doneAction,
        filters: data,
      }));
    });

    const availability = Cookies.getJSON("availability");

    if (typeof window !== "undefined") {
      const shouldAddAvailabilityParams =
        !_.isMatch(location.search, availability) &&
        resource === resourceTypes.lodging;

      const params = Object.assign({},
        { activeFilters: data, dispatch },
        (shouldAddAvailabilityParams && { availability }) || {});

      filterRedirect(params);
    }

    dispatch({
      type: action,
      data: {
        filters,
      },
    });
  };
}

function filterList(options) {
  return fetchNextList({
    ...options,
    type: clientConstants.FILTER_LIST,
  });
}
function fetchList(options) {
  return fetchNextList({
    ...options,
    type: clientConstants.FETCH_LIST,
  });
}

function fetchSubtypesDone(subtypes) {
  return {
    type: clientConstants.FETCH_SUBTYPES_DONE,
    data: subtypes,
  };
}

function fetchSubtypes({
  id,
  resource = "",
  kind = "",
}) {
  return function ajaxFetchSubtypes(dispatch) {
    let url = `/${constants.AJAX_PATH}/subtypes/${id}/${resource}`;

    if (kind) {
      url += `/${kind}`;
    }

    $.ajax({
      url,
      contentType: "application/json",
    })
    .done((subtypes) => dispatch(fetchSubtypesDone((subtypes))))
    .fail((response, status) => {
      dispatch(ajaxError(url, status));
      dispatch(fetchSubtypesDone([]));
    });

    dispatch({
      type: clientConstants.FETCH_SUBTYPES,
    });
  };
}

async function fetchPoiTypesWithData(placeId) {
  try {
    return await $.ajax({
      url: `/${constants.AJAX_PATH}/poitypes/${placeId}`,
      method: "GET",
      contentType: "application/json",
    });
  } catch (e) {
    return [];
  }
}

function showMenuItems(menuItems) {
  return {
    type: clientConstants.FETCH_LIST_MENU_ITEMS_DONE,
    data: menuItems,
  };
}

function excludeTopThingsMenuItem(menuItems) {
  return !menuItems.some(({ type }) => topThingsListItemTypes.includes(type));
}

function getAvailableMenuItems(breadcrumb, placeId) {
  return async (dispatch) => {
    const poiTypesWithData = await fetchPoiTypesWithData(placeId);
    const menuItems = visibleListItemTypes
      // Filter out menu items for poi types that don't have data
      .filter(({ abbrevTitle, kind, resource }) => {
        const type = kind || resource;
        return abbrevTitle === "Top" || poiTypesWithData.some(poiType => poiType === type);
      })
      // Generate the menu item data
      .map(({ abbrevTitle, kind, resource, title }) => ({
        slug: createListUrl({
          breadcrumb: breadcrumb.map(b => b.title),
          kind,
          resource,
          placeId,
        }),
        type: kind || resource,
        title: abbrevTitle || title,
      }));

    // Remove "Top things to do" menu item if none of topThingsListItemTypes are present
    if (excludeTopThingsMenuItem(menuItems)) {
      menuItems.shift();
    }

    dispatch(showMenuItems(menuItems));
  };
}

function infiniteScroll({ page }) {
  return {
    type: clientConstants.INFINITE_SCROLL_LIST,
    data: {
      page,
    },
  };
}

function showPrices(show) {
  return {
    type: clientConstants.SHOW_PRICES,
    data: show,
  };
}

function selectDates({
  startDate, endDate, numNights,
}) {
  return {
    type: clientConstants.SELECT_DATES,
    data: {
      startDate, endDate, numNights,
    },
  };
}

function toggleTakeover(toggle) {
  return {
    type: clientConstants.TOGGLE_TAKEOVER,
    data: toggle,
  };
}

function clearList() {
  return {
    type: clientConstants.CLEAR_LIST,
  };
}

export default {
  fetchNextListDone,
  fetchNextList,
  fetchSubtypes,
  filterList,
  getAvailableMenuItems,
  initList,
  infiniteScroll,
  showPrices,
  selectDates,
  toggleTakeover,
  clearList,
  fetchList,
};



// WEBPACK FOOTER //
// ./assets/list/actions/index.js